import type { AppContext } from 'types/common'
import component from './BreakEven.svelte'
import { graphql } from '$houdini'

type ChartTableColumn = {
	label?: string
	id?: string
	type?: 'string' | 'number' | 'boolean' | 'date' | 'datetime' | 'timeofday'
	role?: string
	p?: { html: boolean }
}

export default ({ mediator, stateRouter }: AppContext) => {
	stateRouter.addState({
		name: 'app.vehicle.break-even',
		route: 'break-even',
		template: { component, svelte: true },
		async resolve(_data, parameters) {
			const { data } = await query.fetch({
				variables: {
					vehicleId: parseInt(parameters.vehicleId, 10) ?? undefined,
				},
			})

			const seriesTitles: Array<ChartTableColumn | string | number | Date | null> = [
				{ label: 'Date', id: 'date' },
				{ label: 'Cost', id: 'cost', type: 'number' },
				{ label: 'Cost of Goods Sold', id: 'costOfGoodsSold', type: 'number' },
				{ type: 'string', role: 'tooltip', p: { html: true } },
				{ label: 'Sales', id: 'sales', type: 'number' },
				{ type: 'string', role: 'tooltip', p: { html: true } },
			]

			const chartData = [seriesTitles].concat(
				(data?.vehicle?.reportData?.breakEven ?? []).reduce(
					(acc: Array<Array<string | number | Date | null>>, item, index) => {
						const lastExpenses = index > 0 ? Number(acc[index - 1][1]) || 0 : 0
						const lastCogs = index > 0 ? Number(acc[index - 1][2]) || 0 : 0
						const lastSales = index > 0 ? Number(acc[index - 1][3]) || 0 : 0
						const itemDateString = item.date.toLocaleDateString('en-US', {
							year: 'numeric',
							month: 'short',
							day: 'numeric',
						})

						acc.push([
							item.date,
							item.expensesTotal ? Number(item.expensesTotal) + lastExpenses : lastExpenses,
							item.costOfGoodsSoldTotal ? Number(item.costOfGoodsSoldTotal) + lastCogs : lastCogs,
							`<strong>${itemDateString}</strong> <br/>Cost of Goods Sold: <strong>$${
								item.costOfGoodsSoldTotal ? Number(item.costOfGoodsSoldTotal) + lastCogs : lastCogs
							} (${item.expensesDescription})</strong>`,
							item.salesTotal ? Number(item.salesTotal) + lastSales : lastSales,
							`<strong>${itemDateString}</strong> <br/>Sales: <strong>$${item.salesTotal} (${item.salesDescription})</strong>`,
						])
						return acc
					},
					[],
				),
			)

			return {
				//
				chartData,
			}
		},
	})
}

const query = graphql(`
	query VehicleBreakEvenReportData($vehicleId: Int!) {
		vehicle(id: $vehicleId) {
			reportData {
				breakEven {
					date
					expensesCount
					# Cost?
					expensesTotal
					expensesDescription
					salesCount
					# Sales
					salesTotal
					salesDescription
					costOfGoodsSoldTotal
				}
			}
		}
	}
`)
